import { useEffect, useState } from "react";
import axios from "axios";
import { useNavigate, useParams } from "react-router-dom";
import CheckboxView from "../../components/view-form-components/checkbox-view";
import {
  FileDownloadView,
  MultiFileDownloadView,
} from "../../components/view-form-components/file-view";
import {
  DocumentView,
  ImageView,
  ImageViewArray,
} from "../../components/view-form-components/image.view";
import { JsonView } from "../../components/view-form-components/json-view";
import RadioView from "../../components/view-form-components/radio-view";
import {
  TextView,
  TextViewArray,
} from "../../components/view-form-components/text-view";
import MainLayout from "../../layout";
import { url } from "../../config";
import { types, uiTypes } from "../../utils/types";
import DeleteModal from "../../components/modal/delete-modal";
import SwitchView from "../../components/view-form-components/switch-view";
import { formatUnderscoreToSpace } from "../../utils/text-format";
import errorToast from "../../components/toast/errorToast";
import CommentsComponent from "../../components/comments/comments";
import FileCommentComponent from "../../components/comments/file-comment";
import backArrow from "../../assets/icons/back-arrow.svg";
import Editor from "../../components/editor";
import EditorView from "../../components/editor/editor-view";
import { ArrowLeft, Edit3, Trash2 } from "lucide-react";
import { MultiImageVideoView } from "../../components/view-form-components/multi-image-video-view";

const ViewPage = ({ model }) => {
  const { id } = useParams();
  const navigate = useNavigate();
  const viewId = id;
  const { tableName, columns, read, edit, create, references } = model;
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [deleteModalShow, setdeleteModalShow] = useState(false);

  const columnHeadings = () => {
    var array = [];
    for (var i = 0; i < columns.length; i++) {
      var column = columns[i];
      if (column.ui?.read == null || column.ui.read == true) {
        array.push(column.name);
      }
    }

    if (references != null) {
      for (let index = 0; index < references.length; index++) {
        const reference = references[index];
        array.push(reference.tableName);
      }
    }
    return array;
  };

  const headings = columnHeadings();

  const deleteFnc = (id) => {
    axios
      .post(`${url}/model/${tableName}/delete`, {
        id: id,
      })
      .then((res) => {
        setData(res.data.data);
        setLoading(false);
        navigate(`/${tableName}/list`);
      })
      .catch((err) => {
        console.error("API Error:", err);
        setLoading(false);
      });
  };

  useEffect(() => {
    if (viewId) {
      axios
        .post(`${url}/model/${tableName}/read`, { id: viewId ?? "" })
        .then((response) => {
          let resData = { ...response.data.data };
          console.log(resData, "resData");

          if (references != null) {
            for (let index = 0; index < references.length; index++) {
              const reference = references[index];
              if (Array.isArray(resData[reference.tableName])) {
                var arrayValues = [];
                for (let j = 0; j < resData[reference.tableName].length; j++) {
                  const element = resData[reference.tableName][j];
                  arrayValues.push(element[reference.displayKey]);
                }
                resData[reference.tableName] = arrayValues.toString();
              } else if (
                resData[reference.tableName] &&
                typeof resData[reference.tableName] === "object"
              ) {
                if (
                  resData[reference.tableName][reference.displayKey] != null
                ) {
                  resData[reference.tableName] =
                    response.data.data[reference.tableName][
                      reference.displayKey
                    ];
                } else {
                  resData[reference.tableName] = "";
                }
              } else {
                resData[reference.tableName] = "";
              }
            }
          }

          setData(resData);
          setLoading(false);
        })
        .catch((error) => {
          errorToast(error?.response?.data?.message);
          console.error("API Error:", error);
          setLoading(false);
        });
    }
  }, [tableName, viewId]);

  if (loading) {
    return (
      <MainLayout>
        <section className="h-full overflow-auto px-4 py-6 bg-slate-50/50 flex justify-center items-center">
          <div className="flex flex-col items-center bg-white p-8 rounded-2xl border border-slate-200/80 shadow-xs">
            <div className="animate-spin rounded-full h-9 w-9 border-3 border-primary border-t-transparent"></div>
            <p className="mt-3 text-xs font-semibold tracking-wide text-slate-500 uppercase">
              Loading Record Details...
            </p>
          </div>
        </section>
      </MainLayout>
    );
  }

  return (
    <MainLayout>
      <DeleteModal
        isOpen={deleteModalShow}
        onClose={() => {
          setdeleteModalShow(false);
        }}
        btnFnc={() => deleteFnc(id)}
      />
      <section className="h-full overflow-auto px-4 sm:px-6 bg-slate-50/40">
        {/* Sticky Header */}

        <div className="sticky top-0 z-[5000] -mx-4 sm:-mx-6 px-4 sm:px-6 py-3 mb-6 bg-white/90 backdrop-blur-md border-b border-slate-200/80 shadow-2xs flex justify-between items-center transition-all">
          {/* Title & Back Navigation */}
          <div className="flex items-center gap-3">
            <button
              onClick={() => navigate(-1)}
              type="button"
              className="p-2 text-slate-500 hover:text-slate-800 hover:bg-slate-100 rounded-xl transition-all border border-slate-200/60 active:scale-95"
              title="Go Back"
            >
              <ArrowLeft className="w-4 h-4 text-slate-600" />
            </button>
            <div>
              <h2 className="text-lg font-bold text-slate-900 capitalize tracking-tight">
                {formatUnderscoreToSpace(tableName)}
              </h2>
              <span className="text-[11px] font-mono text-slate-400 font-medium">
                ID: {id}
              </span>
            </div>
          </div>

          {/* Action Buttons */}
          <div className="flex items-center gap-2">
            <button
              onClick={() => navigate(`/${tableName}/edit/${id}`)}
              className="flex items-center gap-1.5 text-xs md:text-sm font-semibold px-3.5 py-2 bg-primary hover:bg-indigo-700 text-white rounded-xl shadow-xs transition-all active:scale-95"
            >
              <Edit3 className="w-3.5 h-3.5" />
              Edit
            </button>
            <button
              onClick={() => setdeleteModalShow(true)}
              className="flex items-center gap-1.5 text-xs md:text-sm font-semibold px-3.5 py-2 bg-rose-50 hover:bg-rose-100 text-rose-600 border border-rose-200/80 rounded-xl transition-all active:scale-95"
            >
              <Trash2 className="w-3.5 h-3.5" />
              Delete
            </button>
          </div>
        </div>

        {/* Data Cards Container */}
        {data ? (
          <div className="max-w-7xl mx-auto space-y-6">
            <div className="bg-white border border-slate-200/80 rounded-2xl shadow-xs overflow-hidden">
              <div className="px-6 py-4 border-b border-slate-100 bg-slate-50/50 flex items-center justify-between">
                <h3 className="text-xs font-bold uppercase tracking-wider text-slate-500">
                  Overview Details
                </h3>
              </div>

              <div className="p-6">
                <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
                  {headings.map((heading, index) => {
                    const column = columns.find(
                      (value) => value.name === heading,
                    );
                    const value = data[heading];

                    if (column?.ui?.type === uiTypes?.CHECKBOX) {
                      return (
                        <CheckboxView
                          key={index}
                          label={heading}
                          value={value}
                        />
                      );
                    }
                    if (column?.ui?.type === uiTypes?.SWITCH) {
                      return (
                        <SwitchView key={index} label={heading} value={value} />
                      );
                    }
                    if (column?.ui?.type === uiTypes?.RADIO) {
                      return (
                        <RadioView key={index} label={heading} value={value} />
                      );
                    }
                    if (column?.ui?.type === uiTypes.IMAGE) {
                      return (
                        <ImageView key={index} label={heading} value={value} />
                      );
                    }
                    if (column?.ui?.type === uiTypes.DOCUMENT) {
                      return (
                        <DocumentView
                          key={index}
                          label={heading}
                          value={value}
                        />
                      );
                    }
                    if (
                      column?.ui?.read &&
                      column?.isArray &&
                      column?.ui?.type === uiTypes.MULTI_IMAGE
                    ) {
                      return (
                        <div key={index} className="col-span-full">
                          <ImageViewArray label={heading} value={value} />
                        </div>
                      );
                    }
                    if (column?.ui?.type === uiTypes?.FILE) {
                      return (
                        <FileDownloadView
                          key={index}
                          url={value}
                          label={heading}
                        />
                      );
                    }
                    if (
                      column?.isArray &&
                      column?.ui?.type === uiTypes?.MULTI_FILE
                    ) {
                      return (
                        <div key={index} className="col-span-full">
                          <MultiFileDownloadView urls={value} label={heading} />
                        </div>
                      );
                    }
                    if (
                      column?.isArray &&
                      column?.ui?.type === uiTypes?.MULTI_IMAGE_VIDEO
                    ) {
                      return (
                        <div key={index} className="col-span-full">
                          <MultiImageVideoView value={value} />
                        </div>
                      );
                    }
                    if (column?.ui?.type === uiTypes?.JSON) {
                      return (
                        <div key={index} className="col-span-full">
                          <JsonView label={heading} value={value} />
                        </div>
                      );
                    }
                    if (column?.ui?.type === uiTypes?.EDITOR) {
                      return (
                        <div key={index} className="col-span-full">
                          <EditorView
                            value={value}
                            label={heading}
                            read={true}
                          />
                        </div>
                      );
                    }
                    if (column?.isArray && column?.type === types?.STRING) {
                      return (
                        <TextViewArray
                          key={index}
                          label={heading}
                          value={value}
                        />
                      );
                    }
                    return (
                      <TextView key={index} label={heading} value={value} />
                    );
                  })}
                </div>
              </div>
            </div>

            {/* Comments & Interactions */}
            <div className="flex items-start gap-5">
              <div className="bg-white border border-slate-200/80 rounded-2xl p-6 shadow-xs w-full">
                <CommentsComponent tableName={tableName} viewId={viewId} />
              </div>
              <div className="bg-white border border-slate-200/80 rounded-2xl p-6 shadow-xs w-full">
                <FileCommentComponent tableName={tableName} viewId={viewId} />
              </div>
            </div>
          </div>
        ) : (
          <div className="max-w-7xl mx-auto bg-white rounded-2xl border border-slate-200 p-12 text-center text-slate-400 font-medium shadow-xs">
            No record data available.
          </div>
        )}
      </section>
    </MainLayout>
  );
};

export default ViewPage;
